import { useCallback } from 'react';

import FormSpacer from 'bloko/blocks/form/FormSpacer';
import Select, { Option } from 'bloko/blocks/select';

import useTrls from 'hooks/translation/useTrls';

import { ActType, setTypes } from 'store/models/acts';
import { useDispatch, useSelector } from 'store/utils';

const SelectType = () => {
    const selectTypes = useSelector((state) => state.acts.selectTypes);

    const dispatch = useDispatch();

    const trl = useTrls();

    const TYPES = {
        [ActType.All]: trl('admin.actsReport.types.all'),
        [ActType.Clickme]: trl('admin.actsReport.types.clickme'),
        [ActType.HH]: trl('admin.actsReport.types.hh'),
    };

    const onChange = useCallback(
        (event) => {
            dispatch(setTypes(event.target.value));
        },
        [dispatch]
    );
    return (
        <FormSpacer>
            <Select value={selectTypes} onChange={onChange}>
                {Object.entries(TYPES).map(([key, value]) => (
                    <Option key={key} value={key}>
                        {value}
                    </Option>
                ))}
            </Select>
        </FormSpacer>
    );
};

export default SelectType;
